import { posthog } from './analytics';
const KEY_VALUE_STORE = 'keyValueStore';
const STORE_VERSION = 1;
const READ_WRITE = 'readwrite';
const DEBUG = false;
const keyPath = 'key';
function log(msg) {
    if (DEBUG)
        console.log(msg);
}
export async function getKeyValue(key) {
    if (typeof window === 'undefined' || typeof indexedDB === 'undefined')
        return undefined;
    return new Promise((resolve) => {
        try {
            const open = window.indexedDB.open(KEY_VALUE_STORE, STORE_VERSION);
            open.onupgradeneeded = function () {
                try {
                    const db = open.result;
                    db.createObjectStore(KEY_VALUE_STORE, { keyPath });
                }
                catch (err) {
                    console.log(`indexDb::createObjectStore exception: ${err}`);
                    posthog.capture(`indexDb::createObjectStore exception`, { key, error: err });
                    resolve(undefined);
                }
            };
            open.onsuccess = function () {
                try {
                    const db = open.result;
                    const tx = db.transaction(KEY_VALUE_STORE, READ_WRITE);
                    const store = tx.objectStore(KEY_VALUE_STORE);
                    const req = store.get(key);
                    req.onsuccess = function () {
                        try {
                            db.close();
                            log(`indexDb[${key}] -> ${JSON.stringify(req.result, null, 2)}`);
                            if (req && req.result && req.result.value)
                                resolve(req.result.value);
                            else
                                resolve(undefined);
                        }
                        catch (err) {
                            console.log(`indexDb::get exception: ${err}`);
                            posthog.capture(`indexDb::get exception`, { key, error: err });
                            resolve(undefined);
                        }
                    };
                }
                catch (err) {
                    console.log(`indexDb::get exception: ${err}`);
                    posthog.capture(`indexDb::get exception`, { key, error: err });
                    resolve(undefined);
                }
            };
        }
        catch (err) {
            console.log(`indexDb::open exception: ${err}`);
            posthog.capture(`indexDb::open exception`, { key, error: err });
            resolve(undefined);
        }
    });
}
export async function storeKeyValue(key, value) {
    if (typeof window === 'undefined' || typeof indexedDB === 'undefined')
        return false;
    return new Promise((resolve) => {
        try {
            const open = window.indexedDB.open(KEY_VALUE_STORE, STORE_VERSION);
            open.onupgradeneeded = function () {
                try {
                    const db = open.result;
                    db.createObjectStore(KEY_VALUE_STORE, { keyPath });
                }
                catch (err) {
                    console.log(`indexDb::createObjectStore exception: ${err}`);
                    posthog.capture(`indexDb::createObjectStore exception`, { key, error: err });
                    resolve(false);
                }
            };
            open.onsuccess = function () {
                try {
                    const db = open.result;
                    const tx = db.transaction(KEY_VALUE_STORE, READ_WRITE);
                    const store = tx.objectStore(KEY_VALUE_STORE);
                    store.put({ key, value });
                    tx.oncomplete = function () {
                        try {
                            db.close();
                            log(`indexDb[${key}] <- ${JSON.stringify(value, null, 2)}`);
                            resolve(true);
                        }
                        catch (err) {
                            console.log(`indexDb::put exception: ${err}`);
                            posthog.capture(`indexDb::put exception`, { key, error: err });
                            resolve(false);
                        }
                    };
                }
                catch (err) {
                    console.log(`indexDb store exception: ${err}`);
                    posthog.capture(`indexDb store exception`, { key, error: err });
                    resolve(false);
                }
            };
        }
        catch (err) {
            console.log(`indexDb::open exception: ${err}`);
            posthog.capture(`indexDb::open exception`, { key, error: err });
            resolve(false);
        }
    });
}
export async function removeKeyValue(key) {
    if (typeof window === 'undefined' || typeof indexedDB === 'undefined')
        return false;
    return new Promise((resolve) => {
        try {
            const open = window.indexedDB.open(KEY_VALUE_STORE, STORE_VERSION);
            open.onupgradeneeded = function () {
                try {
                    const db = open.result;
                    db.createObjectStore(KEY_VALUE_STORE, { keyPath });
                }
                catch (err) {
                    console.log(`indexDb::createObjectStore exception: ${err}`);
                    posthog.capture(`indexDb::createObjectStore exception`, { key, error: err });
                    resolve(false);
                }
            };
            open.onsuccess = function () {
                try {
                    const db = open.result;
                    const tx = db.transaction(KEY_VALUE_STORE, READ_WRITE);
                    const store = tx.objectStore(KEY_VALUE_STORE);
                    store.delete(key);
                    tx.oncomplete = function () {
                        try {
                            db.close();
                            log(`key [${key}] removed`);
                            resolve(true);
                        }
                        catch (err) {
                            console.log(`indexDb::delete exception: ${err}`);
                            posthog.capture(`indexDb::delete exception`, { key, error: err });
                            resolve(false);
                        }
                    };
                }
                catch (err) {
                    console.log(`indexDb::remove exception: ${err}`);
                    posthog.capture(`indexDb::remove exception`, { key, error: err });
                    resolve(false);
                }
            };
        }
        catch (err) {
            console.log(`indexDb::open exception: ${err}`);
            posthog.capture(`indexDb::open exception`, { key, error: err });
            resolve(false);
        }
    });
}
